import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "service-panel__topbar" }
const _hoisted_2 = {
  key: "guide",
  class: "guide-header"
}
const _hoisted_3 = { class: "guide-profile" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: "compact",
  class: "service-panel__header"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "quick-questions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "message-list"
}
const _hoisted_14 = {
  key: 0,
  class: "message-time"
}
const _hoisted_15 = ["src", "onClick"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 3,
  class: "message-bubble"
}
const _hoisted_18 = {
  key: 4,
  class: "message-retry-area"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 5,
  class: "human-service-card"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 6,
  class: "message-followups"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "thinking-indicator"
}
const _hoisted_26 = {
  key: 0,
  class: "thinking-dots",
  "aria-hidden": "true"
}
const _hoisted_27 = {
  key: 1,
  class: "thinking-label"
}
const _hoisted_28 = { class: "service-panel__composer-area" }
const _hoisted_29 = {
  key: 0,
  class: "sensitive-word-error"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "scroll-bottom-slot"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 0,
  class: "composer-icon-button",
  for: "ai-customer-service-file-input",
  "aria-label": "上传图片"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "message-composer__field" }
const _hoisted_37 = {
  key: 0,
  class: "draft-preview"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = ["onKeydown"]
const _hoisted_41 = ["aria-label", "disabled"]
const _hoisted_42 = ["src", "alt"]
const _hoisted_43 = ["src"]

import { computed, nextTick, onBeforeUnmount, ref, type ComponentPublicInstance } from 'vue'
import {
  aiBaseUrl,
  type AiCustomerChatHistoryItem,
  type AiCustomerChatRecord,
  type AiCustomerChatStreamEvent,
  type AiCustomerFaq,
  getAiCustomerChatRecords,
  getAiCustomerFaqs,
  recordAiCustomerFaq,
  stopAiCustomerChat,
  streamAiCustomerChat,
  uploadAiCustomerFile,
} from '@/api/ai'
import guideAvatar from '@/assets/images/1-ezgif.com-optimize.gif'
import compactAvatar from '@/assets/images/1-ezgif.com-optimize1.gif'
import launcherAvatar from '@/assets/images/aikefu.png'
import sendIcon from '@/assets/images/fasong.png'
import idleSendIcon from '@/assets/images/fasong2.png'
import scrollBottomIcon from '@/assets/images/huidaodibu .png'
import closeIcon from '@/assets/images/huisetu.png'
import draftImageCloseIcon from '@/assets/images/Closeone.png'
import loadingRingIcon from '@/assets/images/lansiquan.png'
import addIcon from '@/assets/images/tianjia.png'
import stopIcon from '@/assets/images/tingzhi.png'
import guideTitle from '@/assets/images/title111.png'
import wechatQrCode from '@/assets/images/xiaokong1.png'
import questionIcon from '@/assets/images/wenti1.png'
import { renderCustomerServiceMarkdown } from '@/utils/customer-service-markdown'
import baocuoIcon from '@/assets/images/baocuo22.png'
import retryIcon from '@/assets/images/chognshi22.png'
import ImagePreviewOverlay from './ImagePreviewOverlay.vue'

type MessageRole = 'assistant' | 'user'

interface SendMessagePayload {
  content?: string
  imageUrl?: string
  fileId?: string
  isHistory?: boolean
}

interface ChatMessage {
  id: number | string
  role: MessageRole
  timestamp?: number
  content?: string
  imageUrl?: string
  fileId?: string
  followupQuestions?: string[]
  isError?: boolean
  retryable?: boolean
  isHumanService?: boolean
}

const AI_CUSTOMER_SERVICE_LAST_OPENED_AT_KEY = 'ai-customer-service-last-opened-at'
const AI_CUSTOMER_SERVICE_CONVERSATION_ID_KEY = 'ai-customer-service-conversation-id'
const AI_CUSTOMER_SERVICE_GUIDE_INTERVAL = 48 * 60 * 60 * 1000


export default /*@__PURE__*/_defineComponent({
  __name: 'AiCustomerService',
  setup(__props) {

const quickQuestions = ref<string[]>([])
const faqAnswers = ref(new Map<string, string>())
const conversationId = ref('')

const isOpen = ref(false)
const isGuideMode = ref(true)
const isHistoryLoading = ref(false)
const isReplying = ref(false)
const isThinking = ref(false)
const isUploadingFile = ref(false)
const thinkingLabelVisible = ref(false)
const draft = ref('')
const draftImageUrl = ref('')
const previewImageUrl = ref('')
const sensitiveWordError = ref(false)
let sensitiveWordErrorTimer: ReturnType<typeof window.setTimeout> | undefined
const draftFileId = ref('')
const messages = ref<ChatMessage[]>([])
const isComposerExpanded = ref(false)
const showScrollBottom = ref(false)
const servicePanelRef = ref<HTMLElement>()
const customerServiceRef = ref<HTMLElement>()
const messageListRef = ref<HTMLElement>()
const fileInputRef = ref<HTMLInputElement>()
const textareaRef = ref<HTMLTextAreaElement>()
const imageObjectUrls = new Set<string>()
let faqReplyTimer: ReturnType<typeof window.setTimeout> | undefined
let thinkingLabelTimer: ReturnType<typeof window.setTimeout> | undefined
let scrollFrame: number | undefined
let autoScrollEnabled = true
let isProgrammaticScroll = false
let lastMessageListScrollTop = 0
let chatStreamController: AbortController | undefined
let skipHistoryForNextRequest = false
let textareaMeasure: HTMLTextAreaElement | undefined
const answerQueues = new Map<number, string>()
const answerQueueTimers = new Map<number, ReturnType<typeof window.setTimeout>>()
const pendingFollowups = new Map<number, string[]>()
const completedStreamMessageIds = new Set<number>()

const setMessageListRef = (element: Element | ComponentPublicInstance | null) => {
  const messageList = element instanceof HTMLElement ? element : undefined
  messageListRef.value = messageList
  if (messageList && isOpen.value && messages.value.length > 0) {
    void scrollToLatestMessage()
  }
}

const canSend = computed(() => Boolean(draft.value.trim() || draftImageUrl.value) && !isUploadingFile.value)
const latestFollowupMessageId = computed(() => {
  const latestMessage = messages.value.at(-1)
  return latestMessage?.role === 'assistant' && !latestMessage.isHumanService && latestMessage.followupQuestions?.length
    ? latestMessage.id
    : undefined
})
const sendButtonIcon = computed(() => (isReplying.value ? stopIcon : canSend.value ? sendIcon : idleSendIcon))
const sendButtonLabel = computed(() => (isReplying.value ? '停止生成' : canSend.value ? '发送消息' : '暂不可发送'))

const loadQuickQuestions = async () => {
  quickQuestions.value = []
  faqAnswers.value = new Map()

  try {
    const response = await getAiCustomerFaqs()
    const items = response.data.filter((item): item is AiCustomerFaq =>
      Boolean(item?.question?.trim() && item?.answer?.trim()),
    )

    if (items.length > 0) {
      quickQuestions.value = items.map((item) => item.question)
      faqAnswers.value = new Map(items.map((item) => [item.question, trimAnswerEnd(item.answer)]))
    }
  } catch (error) {
    console.warn('Failed to load AI customer service FAQs.', error)
  }
}

const loadLatestConversationId = async (shouldShowGuide: boolean) => {
  const savedConversationId = window.localStorage.getItem(AI_CUSTOMER_SERVICE_CONVERSATION_ID_KEY)?.trim()
  conversationId.value = savedConversationId || (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`)
  window.localStorage.setItem(AI_CUSTOMER_SERVICE_CONVERSATION_ID_KEY, conversationId.value)

  if (!shouldShowGuide && conversationId.value) {
    try {
      await loadChatRecords(conversationId.value)
    } finally {
      await nextTick()
      if (messageListRef.value) messageListRef.value.scrollTop = messageListRef.value.scrollHeight
      isHistoryLoading.value = false
    }
  } else {
    isHistoryLoading.value = false
  }
}

const loadChatRecords = async (currentConversationId: string) => {
  try {
    const response = await getAiCustomerChatRecords(currentConversationId, { limit: 100 })
    const records = [...response.data].sort((left, right) => {
      const leftTime = left.askedAt || left.createdAt
      const rightTime = right.askedAt || right.createdAt
      return leftTime - rightTime
    })

    const historyMessages = records.flatMap((record: AiCustomerChatRecord) => {
      const recordMessages: ChatMessage[] = []
      if (record.question || record.files?.length) {
        recordMessages.push({
          id: `${record.id}-question`,
          timestamp: record.askedAt || record.createdAt,
          isHistory: true,
          role: 'user',
          content: record.question || undefined,
          imageUrl: record.files?.[0]?.url,
        })
      }
      if (record.answer) {
        const answer = trimAnswerEnd(record.answer)
        recordMessages.push({ id: `${record.id}-answer`, role: 'assistant', content: answer, followupQuestions: record.followup?.questions?.slice(0, 3), isHumanService: answer.includes('人工客服'), timestamp: record.createdAt })
      }
      return recordMessages
    })

    const currentMessages = messages.value.filter((message) => !historyMessages.some((item) => item.id === message.id))
    messages.value = [...historyMessages, ...currentMessages]

    if (historyMessages.length > 0) {
      isGuideMode.value = false
      await nextTick()
      if (messageListRef.value) messageListRef.value.scrollTop = messageListRef.value.scrollHeight
      // 历史记录渲染及面板过渡动画可能会改变容器高度，分帧再次定位到底部
      requestAnimationFrame(() => {
        void scrollToLatestMessage()
        window.setTimeout(() => void scrollToLatestMessage(), 120)
      })
    }
  } catch (error) {
    console.warn('Failed to load AI customer service chat records.', error)
  }
}

const clearDraftImage = () => {
  if (draftImageUrl.value) {
    URL.revokeObjectURL(draftImageUrl.value)
    imageObjectUrls.delete(draftImageUrl.value)
    draftImageUrl.value = ''
  }
  draftFileId.value = ''
  isUploadingFile.value = false
  if (draft.value) window.requestAnimationFrame(resizeTextarea)
}

const clearReplyTimers = () => {
  if (faqReplyTimer) {
    window.clearTimeout(faqReplyTimer)
    faqReplyTimer = undefined
  }
  if (thinkingLabelTimer) {
    window.clearTimeout(thinkingLabelTimer)
    thinkingLabelTimer = undefined
  }
  answerQueueTimers.forEach((timer) => window.clearTimeout(timer))
  answerQueueTimers.clear()
  answerQueues.clear()
  pendingFollowups.clear()
  completedStreamMessageIds.clear()
}

const showSensitiveWordError = () => {
  if (sensitiveWordErrorTimer) window.clearTimeout(sensitiveWordErrorTimer)
  sensitiveWordError.value = true
  sensitiveWordErrorTimer = window.setTimeout(() => {
    sensitiveWordError.value = false
    sensitiveWordErrorTimer = undefined
  }, 3000)
}

const hideThinkingIndicator = () => {
  if (thinkingLabelTimer) {
    window.clearTimeout(thinkingLabelTimer)
    thinkingLabelTimer = undefined
  }
  thinkingLabelVisible.value = false
  isThinking.value = false
}

const stopReply = (markNextRequestWithoutHistory = false) => {
  if (markNextRequestWithoutHistory) {
    skipHistoryForNextRequest = true
  }
  const activeConversationId = isReplying.value ? conversationId.value : ''
  chatStreamController?.abort()
  chatStreamController = undefined
  clearReplyTimers()

  isReplying.value = false
  hideThinkingIndicator()

  if (activeConversationId) {
    void stopAiCustomerChat(activeConversationId).catch((error) => {
      console.warn('Failed to stop AI customer service response.', error)
    })
  }
}

const open = () => {
  stopReply()
  const lastOpenedAt = Number(window.localStorage.getItem(AI_CUSTOMER_SERVICE_LAST_OPENED_AT_KEY))
  const shouldShowGuide = !lastOpenedAt || Date.now() - lastOpenedAt >= AI_CUSTOMER_SERVICE_GUIDE_INTERVAL

  isGuideMode.value = shouldShowGuide
  isHistoryLoading.value = true
  messages.value = []
  draft.value = ''
  clearDraftImage()
  isComposerExpanded.value = false
  showScrollBottom.value = false
  autoScrollEnabled = true
  lastMessageListScrollTop = 0
  isOpen.value = true
  document.addEventListener('pointerdown', handleDocumentPointerDown)
  void loadQuickQuestions()
  void loadLatestConversationId(shouldShowGuide)
}

const close = () => {
  stopReply()
  isOpen.value = false
  document.removeEventListener('pointerdown', handleDocumentPointerDown)
}

const handleDocumentPointerDown = (event: PointerEvent) => {
  const target = event.target
  const isImagePreview = target instanceof Element && Boolean(target.closest('.preview-overlay'))
  if (target instanceof Node && !customerServiceRef.value?.contains(target) && !isImagePreview) close()
}

const activateConversation = () => {
  isGuideMode.value = false
  window.localStorage.setItem(AI_CUSTOMER_SERVICE_LAST_OPENED_AT_KEY, String(Date.now()))
}

const scrollToLatestMessage = async () => {
  if (!autoScrollEnabled) return
  await nextTick()
  if (scrollFrame !== undefined) {
    cancelAnimationFrame(scrollFrame)
  }
  scrollFrame = requestAnimationFrame(() => {
    const messageList = messageListRef.value
    if (messageList) {
      isProgrammaticScroll = true
      messageList.scrollTop = messageList.scrollHeight
      lastMessageListScrollTop = messageList.scrollTop
      requestAnimationFrame(() => {
        isProgrammaticScroll = false
      })
    }
    scrollFrame = undefined
  })
}

const handleContentScroll = (event: Event) => {
  const content = event.currentTarget as HTMLElement
  const distanceToBottom = content.scrollHeight - content.clientHeight - content.scrollTop
  const scrolledUp = content.scrollTop < lastMessageListScrollTop

  if (!isProgrammaticScroll) {
    if (scrolledUp) {
      autoScrollEnabled = false
    } else if (distanceToBottom <= 40) {
      autoScrollEnabled = true
    }
  }
  lastMessageListScrollTop = content.scrollTop
  showScrollBottom.value = distanceToBottom > 40
}

const scrollToBottom = () => {
  const content = messageListRef.value
  if (!content) return
  autoScrollEnabled = true
  isProgrammaticScroll = true
  content.scrollTo({ top: content.scrollHeight, behavior: 'smooth' })
  window.setTimeout(() => {
    lastMessageListScrollTop = content.scrollTop
    isProgrammaticScroll = false
  }, 300)
}

const measureTextareaHeight = (textarea: HTMLTextAreaElement, padding: string) => {
  if (!textareaMeasure) {
    textareaMeasure = document.createElement('textarea')
    textareaMeasure.setAttribute('aria-hidden', 'true')
    textareaMeasure.tabIndex = -1
    document.body.appendChild(textareaMeasure)
  }

  const computedStyle = window.getComputedStyle(textarea)
  const { width } = textarea.getBoundingClientRect()
  Object.assign(textareaMeasure.style, {
    position: 'fixed',
    top: '-9999px',
    left: '0',
    width: `${width}px`,
    height: '0px',
    minHeight: '0',
    maxHeight: 'none',
    padding,
    boxSizing: 'border-box',
    visibility: 'hidden',
    pointerEvents: 'none',
    overflow: 'hidden',
    resize: 'none',
    fontFamily: computedStyle.fontFamily,
    fontSize: computedStyle.fontSize,
    fontWeight: computedStyle.fontWeight,
    fontStyle: computedStyle.fontStyle,
    letterSpacing: computedStyle.letterSpacing,
    lineHeight: computedStyle.lineHeight,
    whiteSpace: 'pre-wrap',
    overflowWrap: computedStyle.overflowWrap,
    wordBreak: computedStyle.wordBreak,
  })
  textareaMeasure.value = textarea.value
  return textareaMeasure.scrollHeight
}

const resizeTextarea = () => {
  const textarea = textareaRef.value
  if (!textarea) return

  const lineHeight = Number.parseFloat(window.getComputedStyle(textarea).lineHeight) || 24
  const hasImage = Boolean(draftImageUrl.value)
  const collapsedPadding = '0 35px'
  const expandedPadding = '0'
  const imagePadding = '0 0 8px'
  const collapsedHeight = measureTextareaHeight(textarea, collapsedPadding)
  const expanded = Boolean(textarea.value) && collapsedHeight > lineHeight + 2
  isComposerExpanded.value = expanded

  const displayPadding = hasImage ? imagePadding : expanded ? expandedPadding : collapsedPadding
  const maxHeight = hasImage ? 145 : 211
  const displayHeight = expanded ? Math.min(measureTextareaHeight(textarea, displayPadding), maxHeight) : lineHeight
  textarea.style.height = `${displayHeight}px`
}

const handleTextareaEnter = (event: KeyboardEvent) => {
  if (event.isComposing || event.keyCode === 229) return
  event.preventDefault()
  submitDraft()
}

const openFilePicker = () => {
  fileInputRef.value?.click()
}

const handleFileChange = async (event: Event) => {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file) return

  clearDraftImage()
  const imageUrl = URL.createObjectURL(file)
  imageObjectUrls.add(imageUrl)
  draftImageUrl.value = imageUrl
  input.value = ''
  isUploadingFile.value = true

  try {
    const response = await uploadAiCustomerFile(file)
    if (draftImageUrl.value === imageUrl) {
      draftFileId.value = response.data?.fileId ?? ''
    }
  } catch (error) {
    if (draftImageUrl.value === imageUrl) {
      clearDraftImage()
    }
    console.warn('Failed to upload AI customer service file.', error)
  } finally {
    if (draftImageUrl.value === imageUrl) {
      isUploadingFile.value = false
    }
  }
}

const getReply = (question: string) => {
  return faqAnswers.value.get(question) ?? ''
}

const trimAnswerEnd = (content: string) => content.replace(/(?:\r?\n)+\s*$/, '')

const messageTimeLabels = computed(() => {
  const labels = new Map<number | string, 'time' | 'datetime'>()
  const now = new Date()
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  const fourHours = 4 * 60 * 60 * 1000
  let latestMessageOverall: ChatMessage | undefined
  let firstToday: ChatMessage | undefined
  const historicalDays = new Map<number, ChatMessage>()
  const historicalBuckets = new Map<number, ChatMessage>()

  messages.value.forEach((message) => {
    // 时间标签始终显示在用户问题上方，不显示在客服回答上方
    if (message.role !== 'user' || !message.isHistory) return
    if (!message.timestamp) return
    if (!latestMessageOverall || message.timestamp > (latestMessageOverall.timestamp || 0)) latestMessageOverall = message
    if (message.timestamp >= todayStart) {
      if (!firstToday || message.timestamp < (firstToday.timestamp || 0)) firstToday = message
      return
    }
    const date = new Date(message.timestamp)
    const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
    const firstMessage = historicalDays.get(dayStart)
    if (!firstMessage || message.timestamp < (firstMessage.timestamp || 0)) historicalDays.set(dayStart, message)

    const bucket = Math.floor((todayStart - 1 - message.timestamp) / fourHours)
    const latestMessage = historicalBuckets.get(bucket)
    if (!latestMessage || message.timestamp > (latestMessage.timestamp || 0)) historicalBuckets.set(bucket, message)
  })

  if (firstToday) labels.set(firstToday.id, 'datetime')
  historicalBuckets.forEach((message) => labels.set(message.id, 'datetime'))
  historicalDays.forEach((message) => labels.set(message.id, 'datetime'))
  if (latestMessageOverall && (latestMessageOverall.timestamp ?? 0) >= todayStart) {
    labels.set(latestMessageOverall.id, 'time')
  }
  return labels
})
const formatMessageTime = (timestamp: number, includeDate = false) => {
  const date = new Date(timestamp)
  const pad = (value: number) => String(value).padStart(2, '0')
  if (includeDate) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const handleMarkdownLinkClick = (event: MouseEvent) => {
  const link = event.composedPath().find((node): node is HTMLAnchorElement =>
    node instanceof Element && node.tagName.toLowerCase() === 'a',
  ) as HTMLAnchorElement | undefined
  if (!link?.href) {
    return
  }

  event.preventDefault()
  event.stopPropagation()
  const isMallLink = link.getAttribute('href') === 'weixin://shopping/mall/index'
  if (isMallLink) {
    window.location.assign('https://mixedspace.njyjxr.com/#/mall')
    return
  }

  window.open(link.href, '_blank', 'noopener,noreferrer')
}

const saveFaqQuestion = async (question: string, answer: string) => {
  if (!conversationId.value || !question || !answer) return

  try {
    await recordAiCustomerFaq(conversationId.value, { platform: 3, question, answer })
  } catch (error) {
    console.warn('Failed to save AI customer service FAQ record.', error)
  }
}

const getChatHistory = (excludeMessageId?: number | string): AiCustomerChatHistoryItem[] => {
  return messages.value
    .filter((message) => message.id !== excludeMessageId)
    .flatMap((message) => (message.content ? [{ role: message.role, content: message.content }] : []))
    .slice(-3)
}

const normalizeAnswerLineBreaks = (content: string) => content.replace(/\r\n?/g, '\n').replace(/\n{2,}/g, '\n')

const appendStreamContent = (messageId: number, content: string) => {
  const message = messages.value.find((item) => item.id === messageId)
  const nextContent = message?.content?.endsWith('\n') ? content.replace(/^\r?\n+/, '') : content
  answerQueues.set(messageId, normalizeAnswerLineBreaks(`${answerQueues.get(messageId) ?? ''}${nextContent}`))
  if (answerQueueTimers.has(messageId)) return
  const appendNext = () => {
    const queued = answerQueues.get(messageId) ?? ''
    if (!queued) {
      const message = getOrCreateAssistantMessage(messageId)
      const followups = pendingFollowups.get(messageId)
      if (followups?.length && !message.isHumanService) {
        message.followupQuestions = followups
      }
      pendingFollowups.delete(messageId)
      answerQueueTimers.delete(messageId)
      finishAiReplyIfRendered(messageId)
      return
    }
    const message = getOrCreateAssistantMessage(messageId)
    message.content = `${message.content ?? ''}${queued[0]}`
    answerQueues.set(messageId, queued.slice(1))
    answerQueueTimers.set(messageId, window.setTimeout(appendNext, 40))
    void scrollToLatestMessage()
  }
  appendNext()
}

const finishAiReplyIfRendered = (messageId: number) => {
  if (
    !completedStreamMessageIds.has(messageId) ||
    answerQueueTimers.has(messageId) ||
    (answerQueues.get(messageId) ?? '').length > 0
  ) {
    return
  }

  const message = messages.value.find((item) => item.id === messageId)
  if (message?.content) {
    message.content = trimAnswerEnd(message.content)
    if (message.content.includes('人工客服')) {
      message.isHumanService = true
      message.followupQuestions = undefined
    }
  }
  completedStreamMessageIds.delete(messageId)
  isReplying.value = false
  hideThinkingIndicator()
}

const getOrCreateAssistantMessage = (messageId: number) => {
  let message = messages.value.find((item) => item.id === messageId)
  if (!message) {
    message = { id: messageId, role: 'assistant' }
    messages.value.push(message)
  }
  return message
}

const handleAiStreamEvent = (messageId: number, event: AiCustomerChatStreamEvent) => {
  if (event.type === 'done') {
    completedStreamMessageIds.add(messageId)
    finishAiReplyIfRendered(messageId)
    return
  }

  if (event.type === 'classify' || event.type === 'retrieval' || event.type === 'think' || event.type === 'warning') {
    return
  }

  const message = getOrCreateAssistantMessage(messageId)
  switch (event.type) {
    case 'answer':
      if (event.content) {
        hideThinkingIndicator()
        appendStreamContent(messageId, event.content)
      }
      return
    case 'correction':
      if (event.content) {
        const correction = normalizeAnswerLineBreaks(trimAnswerEnd(event.content))
        const renderedContent = message.content ?? ''
        const timer = answerQueueTimers.get(messageId)
        if (timer) window.clearTimeout(timer)
        answerQueueTimers.delete(messageId)
        answerQueues.delete(messageId)
        if (correction.startsWith(renderedContent)) {
          appendStreamContent(messageId, correction.slice(renderedContent.length))
        } else {
          appendStreamContent(messageId, correction)
        }
      }
      break
    case 'followup':
      if (event.questions?.length && !message.isHumanService) {
        if ((answerQueues.get(messageId) ?? '').length > 0) pendingFollowups.set(messageId, event.questions)
        else message.followupQuestions = event.questions
      }
      break
  }

  void scrollToLatestMessage()
}

const requestAiAnswer = async (query: string, fileId: string, history: AiCustomerChatHistoryItem[]) => {
  if (!conversationId.value) return

  const controller = new AbortController()
  chatStreamController = controller
  const assistantMessageId = Date.now() + 1
  let requestFailed = false

  try {
    const request = { platform: 3, query, fileIds: fileId ? [fileId] : undefined, history }
    await streamAiCustomerChat(
      conversationId.value,
      request,
      (event) => {
        if (!controller.signal.aborted) {
          handleAiStreamEvent(assistantMessageId, event)
        }
      },
      controller.signal,
    )
  } catch (error) {
    if (!controller.signal.aborted) {
      requestFailed = true
      console.warn('Failed to request AI customer service response.', error)
      const userMessage = messages.value.slice().reverse().find((message) => message.role === 'user' && !message.retryable)
      if (userMessage) userMessage.retryable = true
    }
  } finally {
    if (chatStreamController === controller) {
      chatStreamController = undefined
      completedStreamMessageIds.add(assistantMessageId)
      if (!controller.signal.aborted) {
        const assistantMessage = messages.value.find((message) => message.id === assistantMessageId)
        if (!assistantMessage?.content) {
          const userMessage = messages.value.slice().reverse().find((message) => message.role === 'user' && !message.retryable)
          if (userMessage) userMessage.retryable = true
          if (assistantMessage) {
            const messageIndex = messages.value.findIndex((item) => item.id === assistantMessageId)
            if (messageIndex >= 0) messages.value.splice(messageIndex, 1)
          } else if (!requestFailed) {
            // 空响应只显示提问下方的重试状态，不追加错误客服消息。
          }
        }
      }
      finishAiReplyIfRendered(assistantMessageId)
      await scrollToLatestMessage()
    }
  }
}

const streamFaqAnswer = (answer: string) => {
  const assistantMessage: ChatMessage = { id: Date.now() + 1, role: 'assistant', content: '' }
  const characters = Array.from(normalizeAnswerLineBreaks(answer))
  let cursor = 0
  assistantMessage.timestamp = Date.now()
  messages.value.push(assistantMessage)

  const appendNextCharacter = async () => {
    if (!isReplying.value || cursor >= characters.length) {
      const finalContent = trimAnswerEnd(assistantMessage.content ?? '')
      assistantMessage.content = finalContent
      if (finalContent.includes('人工客服')) {
        assistantMessage.isHumanService = true
        assistantMessage.followupQuestions = undefined
      }
      messages.value = messages.value.map((message) =>
        message.id === assistantMessage.id ? { ...message, content: finalContent } : message,
      )
      isReplying.value = false
      faqReplyTimer = undefined
      void scrollToLatestMessage()
      return
    }

    if (!assistantMessage.content) hideThinkingIndicator()
    const character = characters[cursor] ?? ''
    const nextContent = `${assistantMessage.content ?? ''}${character}`
    assistantMessage.content = nextContent
    messages.value = messages.value.map((message) =>
      message.id === assistantMessage.id ? { ...message, content: nextContent } : message,
    )
    cursor += 1
    await nextTick()
    await new Promise<void>((resolve) => window.requestAnimationFrame(() => resolve()))
    if (cursor % 6 === 0 || cursor >= characters.length) {
      void scrollToLatestMessage()
    }

    const lastCharacter = characters[cursor - 1] ?? ''
    const delay = /[。！？；：.!?;:]/.test(lastCharacter) ? 210 : /[，、,]/.test(lastCharacter) ? 125 : 65
    faqReplyTimer = window.setTimeout(appendNextCharacter, 40)
  }

  faqReplyTimer = window.setTimeout(appendNextCharacter, 180)
}

const sendMessage = async ({ content = '', imageUrl = '', fileId = '' }: SendMessagePayload, existingMessage?: ChatMessage) => {
  const question = content.trim()
  if ((!question && !imageUrl) || isReplying.value) {
    return
  }

  if (messages.value.length === 0 && conversationId.value) {
    await loadChatRecords(conversationId.value)
    isHistoryLoading.value = false
  }
  activateConversation()
  isHistoryLoading.value = false
  messages.value.forEach((message) => {
    message.followupQuestions = undefined
  })
  const history = skipHistoryForNextRequest ? [] : getChatHistory(existingMessage?.id)
  skipHistoryForNextRequest = false
  const faqAnswer = question ? getReply(question) : ''
  if (faqAnswer) {
    void saveFaqQuestion(question, faqAnswer)
  }
  if (existingMessage) {
    existingMessage.retryable = false
  } else {
    messages.value.push({
      id: Date.now(),
      role: 'user',
      timestamp: Date.now(),
      content: question || undefined,
      imageUrl: imageUrl || undefined,
      fileId: fileId || undefined,
    })
  }
  clearReplyTimers()
  thinkingLabelVisible.value = false
  isThinking.value = true
  isReplying.value = true
  thinkingLabelTimer = window.setTimeout(() => {
    thinkingLabelVisible.value = true
    thinkingLabelTimer = undefined
    void scrollToLatestMessage()
  }, 520)
  await scrollToLatestMessage()

  if (faqAnswer) {
    streamFaqAnswer(faqAnswer)
  } else {
    void requestAiAnswer(question, fileId, history)
  }
}

const submitDraft = async () => {
  if (!canSend.value || isReplying.value) {
    return
  }

  sensitiveWordError.value = false
  if (draft.value.trim()) {
    try {
      const response = await fetch(`${aiBaseUrl}/sensitive/sensitiveWord/contains?text=${encodeURIComponent(draft.value.trim())}`, { method: 'POST' })
      const result = await response.json()
      if (result?.data === true || result?.data?.data === true) {
        showSensitiveWordError()
        return
      }
    } catch (error) {
      showSensitiveWordError()
      return
    }
  }
  const imageUrl = draftImageUrl.value
  const fileId = draftFileId.value
  const content = draft.value

  await sendMessage({ content, imageUrl, fileId })
  draft.value = ''
  draftImageUrl.value = ''
  draftFileId.value = ''
  await nextTick()
  resizeTextarea()
}

const retryMessage = (message: ChatMessage) => {
  if (isReplying.value) return
  message.retryable = false
  void sendMessage({ content: message.content, imageUrl: message.imageUrl, fileId: message.fileId }, message)
}

onBeforeUnmount(() => {
  if (sensitiveWordErrorTimer) window.clearTimeout(sensitiveWordErrorTimer)
  document.removeEventListener('pointerdown', handleDocumentPointerDown)
  stopReply()
  textareaMeasure?.remove()
  textareaMeasure = undefined
  imageObjectUrls.forEach((imageUrl) => URL.revokeObjectURL(imageUrl))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "customerServiceRef",
    ref: customerServiceRef,
    class: _normalizeClass(["ai-customer-service", { 'ai-customer-service--open': isOpen.value }])
  }, [
    _createVNode(_Transition, { name: "ai-service-panel" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "servicePanelRef",
              ref: servicePanelRef,
              class: "service-panel",
              "aria-label": "AI 智能客服",
              onPointerdown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
              onWheel: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_Transition, {
                  name: "ai-service-header",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (isGuideMode.value && !isHistoryLoading.value)
                      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                              src: _unref(guideAvatar),
                              alt: "小空 AI 智能助手",
                              class: "guide-avatar"
                            }, null, 8, _hoisted_4),
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: _unref(guideTitle),
                                alt: "我是小空",
                                class: "guide-title"
                              }, null, 8, _hoisted_5),
                              _cache[6] || (_cache[6] = _createElementVNode("span", null, "您的AI智能助手", -1))
                            ])
                          ]),
                          _createElementVNode("img", {
                            src: _unref(closeIcon),
                            alt: "关闭 AI 客服",
                            class: "guide-close-icon",
                            onClick: close
                          }, null, 8, _hoisted_6)
                        ]))
                      : (_openBlock(), _createElementBlock("header", _hoisted_7, [
                          _createElementVNode("img", {
                            src: _unref(compactAvatar),
                            alt: "小空 AI 智能助手",
                            class: "service-panel__avatar"
                          }, null, 8, _hoisted_8),
                          _cache[7] || (_cache[7] = _createElementVNode("h2", null, "小空", -1)),
                          _createElementVNode("img", {
                            src: _unref(closeIcon),
                            alt: "关闭 AI 客服",
                            class: "close-icon",
                            onClick: close
                          }, null, 8, _hoisted_9)
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                ref: setMessageListRef,
                class: _normalizeClass(["service-panel__content", { 'service-panel__content--guide': isGuideMode.value }]),
                onScroll: handleContentScroll
              }, [
                (!isHistoryLoading.value && messages.value.length === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "service-panel__prompt" }, "有什么可以帮你?", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickQuestions.value, (question) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: question,
                            class: "quick-question",
                            type: "button",
                            onClick: ($event: any) => (sendMessage({ content: question }))
                          }, [
                            _createElementVNode("img", {
                              src: _unref(questionIcon),
                              alt: ""
                            }, null, 8, _hoisted_12),
                            _createElementVNode("span", null, _toDisplayString(question), 1)
                          ], 8, _hoisted_11))
                        }), 128))
                      ])
                    ], 64))
                  : (!isHistoryLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: message.id,
                            class: _normalizeClass(["message-row", `message-row--${message.role}`])
                          }, [
                            (message.role === 'user' && messageTimeLabels.value.has(message.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(formatMessageTime(message.timestamp!, messageTimeLabels.value.get(message.id) === 'datetime')), 1))
                              : _createCommentVNode("", true),
                            (message.imageUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: message.imageUrl,
                                  alt: "用户上传的图片",
                                  class: "message-image",
                                  onClick: ($event: any) => (previewImageUrl.value = message.imageUrl)
                                }, null, 8, _hoisted_15))
                              : _createCommentVNode("", true),
                            (message.content && message.role === 'assistant')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: _normalizeClass(["message-bubble", { 'message-bubble--error': message.isError }]),
                                  onClick: handleMarkdownLinkClick,
                                  innerHTML: _unref(renderCustomerServiceMarkdown)(message.content, isReplying.value && message.id === messages.value.at(-1)?.id)
                                }, null, 10, _hoisted_16))
                              : (message.content && message.role === 'user')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(message.content), 1))
                                : _createCommentVNode("", true),
                            (message.role === 'user' && message.retryable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "message-retry-status" }, "小空正在忙碌中，请稍等", -1)),
                                  _createElementVNode("button", {
                                    class: "message-retry-button",
                                    type: "button",
                                    onClick: ($event: any) => (retryMessage(message))
                                  }, [
                                    _createElementVNode("img", {
                                      src: _unref(retryIcon),
                                      alt: ""
                                    }, null, 8, _hoisted_20),
                                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "重试", -1))
                                  ], 8, _hoisted_19)
                                ]))
                              : _createCommentVNode("", true),
                            (message.role === 'assistant' && message.isHumanService)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "联系我们的客户经理：", -1)),
                                  _createElementVNode("img", {
                                    src: _unref(wechatQrCode),
                                    alt: "微信扫码咨询",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (previewImageUrl.value = _unref(wechatQrCode)))
                                  }, null, 8, _hoisted_22),
                                  _cache[12] || (_cache[12] = _createElementVNode("span", null, "微信扫码咨询", -1))
                                ]))
                              : _createCommentVNode("", true),
                            (message.role === 'assistant' && !message.isHumanService && message.id === latestFollowupMessageId.value && message.followupQuestions?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.followupQuestions.slice(0, 3), (question) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: question,
                                      type: "button",
                                      onClick: ($event: any) => (sendMessage({ content: question }))
                                    }, _toDisplayString(question), 9, _hoisted_24))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128)),
                        (isThinking.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              (!thinkingLabelVisible.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", null, null, -1),
                                    _createElementVNode("i", null, null, -1),
                                    _createElementVNode("i", null, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (thinkingLabelVisible.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "小空正在思考中..."))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
              ], 34),
              _createElementVNode("div", _hoisted_28, [
                (sensitiveWordError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("img", {
                        src: _unref(baocuoIcon),
                        alt: ""
                      }, null, 8, _hoisted_30),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "当前内容暂无法处理，请调整后重试", -1))
                    ]))
                  : _createCommentVNode("", true),
                (showScrollBottom.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("button", {
                        class: "scroll-bottom-button",
                        type: "button",
                        "aria-label": "回到底部",
                        onClick: scrollToBottom
                      }, [
                        (isReplying.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(loadingRingIcon),
                              alt: "",
                              class: "scroll-bottom-spinner"
                            }, null, 8, _hoisted_32))
                          : _createCommentVNode("", true),
                        _createElementVNode("img", {
                          src: _unref(scrollBottomIcon),
                          alt: "",
                          class: "scroll-bottom-icon"
                        }, null, 8, _hoisted_33)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  class: _normalizeClass(["message-composer", { 'message-composer--expanded': isComposerExpanded.value, 'message-composer--with-image': draftImageUrl.value }]),
                  onSubmit: _withModifiers(submitDraft, ["prevent"])
                }, [
                  _createElementVNode("input", {
                    ref_key: "fileInputRef",
                    ref: fileInputRef,
                    id: "ai-customer-service-file-input",
                    class: "file-input",
                    type: "file",
                    accept: "image/*",
                    "aria-label": "上传图片",
                    onChange: handleFileChange
                  }, null, 544),
                  (!draftImageUrl.value)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_34, [
                        _createElementVNode("img", {
                          src: _unref(addIcon),
                          alt: ""
                        }, null, 8, _hoisted_35)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_36, [
                    (draftImageUrl.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("img", {
                            src: draftImageUrl.value,
                            alt: "待发送图片",
                            class: "draft-image"
                          }, null, 8, _hoisted_38),
                          _createElementVNode("button", {
                            class: "draft-image__remove",
                            type: "button",
                            "aria-label": "删除图片",
                            onClick: clearDraftImage
                          }, [
                            _createElementVNode("img", {
                              src: _unref(draftImageCloseIcon),
                              alt: ""
                            }, null, 8, _hoisted_39)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "textareaRef",
                      ref: textareaRef,
                      class: _normalizeClass({ 'message-composer__textarea--expanded': isComposerExpanded.value, 'message-composer__textarea--with-image': draftImageUrl.value }),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((draft).value = $event)),
                      "aria-label": "输入咨询内容",
                      placeholder: "请输入内容",
                      rows: "1",
                      maxlength: "200",
                      onInput: resizeTextarea,
                      onKeydown: _withKeys(_withModifiers(handleTextareaEnter, ["exact"]), ["enter"])
                    }, null, 42, _hoisted_40), [
                      [_vModelText, draft.value]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "send-button",
                    type: "button",
                    "aria-label": sendButtonLabel.value,
                    disabled: !canSend.value && !isReplying.value,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isReplying.value ? stopReply(true) : submitDraft()))
                  }, [
                    _createElementVNode("img", {
                      src: sendButtonIcon.value,
                      class: "send-button__icon",
                      alt: sendButtonLabel.value
                    }, null, 8, _hoisted_42)
                  ], 8, _hoisted_41)
                ], 34)
              ])
            ], 544))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!isOpen.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "service-launcher",
          type: "button",
          "aria-label": "打开 AI 客服",
          onClick: open
        }, [
          _createElementVNode("img", {
            src: _unref(launcherAvatar),
            alt: ""
          }, null, 8, _hoisted_43)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ImagePreviewOverlay, {
      visible: Boolean(previewImageUrl.value),
      "image-url": previewImageUrl.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (previewImageUrl.value = ''))
    }, null, 8, ["visible", "image-url"])
  ], 2))
}
}

})